import { Injectable } from '@angular/core';
import { BaseHttpService } from '../base/base-http.service';
import { CommandDto } from '../../models/base/base';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommandService extends BaseHttpService<CommandDto>{
  private url = environment.baseUrl + this.getResourceUrl();

  constructor(private httpClinet: HttpClient) {
    super(httpClinet);
  }

  getResourceUrl(): string {
    return 'Command';
  }

  //https://host.tabmshr.com/api/v1/Command/ExeStoredProcedure?additionalProp1=string&additionalProp2=string&additionalProp3=string&DataBaseName=%27%27&StoredName=addtoBlacklist

  execStoredProcedure(recordid, functionname){
    let request = `${this.url}/ExeStoredProcedure`;
    let params = {additionalprop1: recordid, databasename: '', storedname: functionname};
    return this.httpClinet.get<any>(request, { params: params });
  }

}
